// import ReactGA from "react-ga"
import ReactGA from "react-ga4" // use this import for google analaytics bcs we use id of this not universal analytics

//const TRACKING_ID = "UA-195152411-1"
const TRACKING_ID = "G-PS3CK3MYP0"


function init() {
    // Enable debug mode on the local development environment
    // const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ReactGA.initialize(TRACKING_ID)
}

function sendEvent({ name, params }) {
    console.log("Event sent:", name, params);
    ReactGA.event(name, params);
  }

function sendPageview(path) {
    ReactGA.set({ page: path })
    ReactGA.pageview(path)
}

export default {
    init,
    sendEvent,
    sendPageview,
}
